/**
 * Generates an alphanumeric string of a specified character length (defaults to 16 characters).
 *
 * @example
 * import createId from '@carvana/futilities/createId';
 * createId()
 * // () => '23b0sh3a2bhbqqng'
 * createId(3)
 * // () => '3by'
 */
function createId(len = 16, charSet = 'abcdefghijklmnopqrstuvwxyz0123456789') {
  let text = '';
  let count = len;
  const charSetLength = charSet.length;
  while (count--) {
    text += charSet.charAt(Math.floor(Math.random() * charSetLength));
  }
  return text;
}

export default createId;
